import styled from 'styled-components'
import Dropdown from 'react-bootstrap/Dropdown'

export const StyledDropdownDivider = styled(Dropdown.Divider)`
  && {
    height: 0;
    margin: var(--gutter-default) var(--margin-default);
  }
`
